import { Component, OnDestroy, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppService } from '../../../../app.service';
import { AuthService } from '../../../../core/guards/auth.service';
import { AlertService } from '../../../shared/alert/alert.service';

@Component({

  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnDestroy {
  closeLoginDialogSubscription!: Subscription;
  loginForm: FormGroup
  result: any
  isLogin: boolean = false;
  loggedIn: boolean = true;
  email: string = '';
  password: string = '';
  constructor(
    public fb: FormBuilder,
    @Optional() private readonly dialogRef: MatDialogRef<LoginComponent>,
    private readonly route: ActivatedRoute,
    private readonly commonservice: AppService,
    public authService: AuthService,
    public router: Router,
    public alertService: AlertService,
    public sessionService: AuthService, public dialog: MatDialog
  ) {
    this.loginForm = this.fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
      rememberMe: [false]
    })
    this.loginForm.reset()
  }

  loginData: any;
  /** true while login API is in progress - show loader on button */
  loginInProgress = false;

  login() {
    const mail = this.loginForm.controls['email'].value;
    const password = this.loginForm.controls['password'].value;
    const rememberMe = this.loginForm.controls['rememberMe'].value;
    const rawCredentials = localStorage.getItem('savedcredentials');
    let savedCredentials: { mail: string, password: string }[] = [];

    try {
      const parsed = JSON.parse(rawCredentials || '[]');
      savedCredentials = Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      console.error('Failed to parse saved credentials:', e);
      savedCredentials = [];
    }

    if (rememberMe) {
      const existingIndex = savedCredentials.findIndex((cred) => cred.mail === mail);

      if (existingIndex > -1) {
        savedCredentials[existingIndex].password = password;
      } else {
        savedCredentials.push({ mail, password });
      }

      localStorage.setItem('savedcredentials', JSON.stringify(savedCredentials));
    } else {
      savedCredentials = savedCredentials.filter((cred) => cred.mail !== mail);
      localStorage.setItem('savedcredentials', JSON.stringify(savedCredentials));
    }
    if (this.loginForm.valid) {
      this.loginInProgress = true;

      if (mail == "admin@tscti.com" && password == "Welcome@1234") {
        this.router.navigate(['smartdocs/filer-summary']);
        localStorage.setItem('userName', 'Admin');
        localStorage.setItem('userID', '1');
        this.commonservice.cadStatusData.next(true);
        this.commonservice.loginData.next(this.loginData);

        localStorage.setItem('authToken', "123");
        localStorage.setItem('appUserID', "1");
        let email = this.loginForm.controls['email'].value.replaceAll('"', '');
        localStorage.setItem('userDetails', email);
      } else {
        this.loginInProgress = false;
        this.alertService.error("Login Failed");
      }


      // this.authService.login(mail, password).subscribe({
      //   next: (response) => {
      //     this.loginInProgress = false;
      //     this.loginData = response;

      //     let roles: string[] = [];
      //     if (Array.isArray(response.roles)) {
      //       roles = response.roles;
      //     } else if (response.roles) {
      //       roles = [response.roles];
      //     }

      //     let services: string[] = [];
      //     if (Array.isArray(response.services)) {
      //       services = response.services;
      //     } else if (response.services) {
      //       services = [response.services];
      //     }
      //     localStorage.setItem('services', JSON.stringify(services));
      //     localStorage.setItem('roles', roles[0] ?? '');
      //     localStorage.setItem('userName', response.userName ?? '');
      //     localStorage.setItem('userID', response.userID ?? '');
      //     localStorage.setItem('gracePeriodDays', response.gracePeriodDays ?? '');
      //     localStorage.setItem('isImpersonated', 'false');

      //     const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '';
      //     this.router.navigate(['smartdocs/smartdocs-dashboard']);

      //     this.setToken(response);
      //     this.isLogin = true;
      //     this.alertService.success('User logged in successfully');
      //     this.commonservice.cadStatusData.next(this.isLogin);
      //     this.commonservice.loginData.next(this.loginData);
      //   },
      //   error: (err) => {
      //     this.loginInProgress = false;
      //     this.alertService.error(err.error.message);
      //   }
      // });
    }
  }


  setToken(response: any): void {
    localStorage.setItem('authToken', response.token);
    localStorage.setItem('appUserID', response.appUserID);
    let email = this.loginForm.controls['email'].value.replaceAll('"', '');
    localStorage.setItem('userDetails', email);
  }
  logout(): void {
    this.sessionService.logout();
    this.router.navigate(['/login'])
  }

  onLoginSubmit() {
    console.log('Email:', this.email);
    console.log('Password:', this.password);
  }

  forgotPassword() {
    this.router.navigate(['/forgot-password']);
  }


  isPasswordVisible: boolean = false;

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  changeUserName(event: any) {
    const fieldValue = event.target.value;
    const savedCredentials = localStorage.getItem('savedcredentials') || '[]';
    const credentialsArray: { mail: string; password: string }[] = JSON.parse(savedCredentials);
    const x = credentialsArray.filter((item) => item.mail === fieldValue);
    const isIncludes = x.length > 0;
    if (isIncludes) {
      this.loginForm.patchValue({
        email: x[0].mail,
        password: x[0].password,
        rememberMe: true
      });
    } else {
      this.loginForm.patchValue({
        password: '',
        rememberMe: false
      });
    }

  }
  loadChatWidget() {
    (function (w: any, d: Document, x: string, id: string) {
      const s = d.createElement('script');
      s.src = 'https://tscti-demo.my.connect.aws/connectwidget/static/amazon-connect-chat-interface-client.js';
      s.async = true;
      s.id = id;
      d.getElementsByTagName('head')[0].appendChild(s);
      w[x] = w[x] || function () {
        w[x].ac = w[x].ac || [];
        w[x].ac.push(arguments);
      };
    })(globalThis, document, 'amazon_connect', 'efcaa476-986c-4025-aac5-9727c4680d07');
    (globalThis as any).amazon_connect('styles', {
      iconType: 'CHAT',
      openChat: {
        color: '#ffffff',
        backgroundColor: '#1E569A',
      },
      closeChat: {
        color: '#ffffff',
        backgroundColor: '#1E569A',
      }
    });
    (globalThis as any).amazon_connect(
      'snippetId', 'QVFJREFIaXdlaTllQXR1SnQyK1JZc1Z3dWE3clBZQjQvWm15emlVb25scEltc3BJNmdGRUVNTGUvN3NpYkJTUUtBZlhnL2Z6QUFBQWJqQnNCZ2txaGtpRzl3MEJCd2FnWHpCZEFnRUFNRmdHQ1NxR1NJYjNEUUVIQVRBZUJnbGdoa2dCWlFNRUFTNHdFUVFNd0NBUFAxSXZjR0FJRjM4M0FnRVFnQ3Uvc2s1TVJNMVVDeXVxVlpiT3o1aEpKZE5kUEczanN6ZXNDWFFjb1ZRL3laeFpQbW9jazRxY1F3aGk6OmhzVjBUck9mbFFOeUFialh6TndKTGhKelRwZGJWZ0RMYzhIRDNhYk9EcFQvNk1FNFRvRlc5cE9MUGF3VjBFenhlK2czdVRiL0ZZMGNGNmZuajBic0Vudk9DWmJzUGxvRnFMN2pPNVlVZmZlSXl6RFp4UEdObm9YejJlVmNKTFdDL0w5ZHR4bGxLRmg1TTNPN2tLWVNVRFh5RTBtdmxncz0=');
    (globalThis as any).amazon_connect('supportedMessagingContentTypes', [
      'text/plain',
      'text/markdown',
      'application/vnd.amazonaws.connect.message.interactive',
      'application/vnd.amazonaws.connect.message.interactive.response',
    ]);
    setTimeout(() => {
      const el = document.querySelector('.bPeSiV') as HTMLElement;
      if (el) {
        el.style.backgroundColor = '#1E569A';
      }
    }, 3000);
  }

  ngOnDestroy(): void {
  }
}
